export const nmmsSubjectIds = [29, 31, 33, 74];

const getSubjectId = (item) => {
  const raw = item?.id ?? item?.subject_id ?? item?.subjectId ?? item?.kram;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

export const filterNmmsSubjects = (subjects) => {
  const allowedIds = nmmsSubjectIds;

  return (subjects || [])
    .map((item) => {
      const id = getSubjectId(item);
      if (id == null) return item;
      if (item?.id != null) return item;
      return { ...item, id };
    })
    .filter((item) => {
      const id = getSubjectId(item);
      return id != null && allowedIds.includes(id);
    })
    .sort(
      (a, b) =>
        allowedIds.indexOf(getSubjectId(a)) - allowedIds.indexOf(getSubjectId(b))
    );
};
